import React, { useEffect, useState } from "react";
import Day1Card from "../../day1_card/Day1_Card";
import Day2Card from "../../day2_card/Day2_Card";
import Day3Card from "../../day3_card/Day3_Card";
import { Accordion } from "react-bootstrap";
import "./Itinerary_Tab.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const Itinerary_Tab = ({ data }) => {
  const [activeTab, setActiveTab] = useState("Itinerary");
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const itineraryData = [
    {
      type: "stay",
      city: "Reykjavik",
      days: "3 Days",
      title: "Day 01 – Arrival in Reykjavik | Day at Leisure",
      description:
        "Welcome to Iceland! Upon arrival at the airport, get transferred to your hotel. Post check-in, spend the rest of your day at leisure, where you can explore Iceland's capital on your own. You can dive into Reykjavik's Viking history at the Settlement Exhibition, which showcases the remains of a 10th-century longhouse, or witness the Icelandic natural wonders at the Perlan Museum, where interactive exhibits. Also, soak-in the amazing views from the observation deck before returning to your hotel.",
      hotel: "Hotel Reykjavik Grand",
      checkIn: "2:00 PM",
      checkOut: "11:00 PM",
      nights: "3N",
      transferType: "Private Transfer",
      transferMode: "Transfer in Sedan",

      from: "Keflavik International Airport",
      to: "Hotel Reykjavik Grand in Reykjavik",
      mainImage: "/assets/images/cruise/itenarary/Hotel_main-img.png",
      thumbnails: [
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
        "/assets/images/cruise/itenarary/Hotel_image.png",
      ],
    },

    {
      type: "activity",
      title: "Day 02 – Day Trip to Iceland Golden Circle",
      description:
        "Today, board your transfer to explore Iceland's Golden Circle. Start with a visit to Thingvellir National Park, a UNESCO World Heritage site where you can walk between the North American and Eurasian tectonic plates. Next, marvel at the thundering Gullfoss Waterfall and experience the geothermal spectacle of the Geysers, where the Strokkur geyser erupts every few minutes. After an amazing day, get driven back to your hotel for an overnight stay.",
      activityTitle: "Golden Circle Tour on a Shared basis",

      activityImages: [
        "/assets/images/cruise/itenarary/day2-scroll-img.png",
        "/assets/images/cruise/itenarary/day2-scroll-img.png",
      ],

      from: "Keflavik International Airport",
      to: "Hotel Reykjavik Grand in Reykjavik",

      transferType: "Shared Transfer",
      transferMode: "Transfer in Coach",

      experiences: [
        { img: "/assets/images/cruise/itenarary/day2-img1.png" },
        { img: "/assets/images/cruise/itenarary/day2-img2.png" },
        { img: "/assets/images/cruise/itenarary/day2-img3.png" },
      ],
    },

    {
      type: "flight",
      title: "Day 03 – Transfer to Akureyri | Day at Leisure",
      description:
        "Today, after check-out, board your transfer to Reykjavik Airport for your flight to Akureyri. Upon arrival at Akureyri Airport, get transferred to your hotel and check-in. Then, spend the rest of your day at leisure. You can explore the serene Akureyri Botanical Garden, home to a diverse collection of Arctic and temperate plants, or stroll through The Old Town, where you can admire the charming wooden houses and soak in the local culture. Afterwards, return to your hotel for an overnight stay.",

      airline: "Icelandair",

      type: "flight",
      airline: "Icelandair",

      from: "RKV",
      fromCity: "Iceland",

      to: "AEY",
      toCity: "Akureyri",

      departTime: "15:30",
      arriveTime: "16:15",

      duration: "45m",

      baggageCabin: "N/A",
      baggageCheckin: "N/A",

      refund: "Non Refundable",

      transferType: "Private Transfer",
      transferMode: "Transfer in Sedan",
    },
  ];

  const icons = {
    meal: "/assets/images/cruise/itenarary/day-meal.png",
    checkout: "/assets/images/cruise/itenarary/checkout.png",
    car: "/assets/images/cruise/itenarary/private-tranfer.png",
    bed: "/assets/images/cruise/itenarary/bed-img.png",
    map: "/assets/images/cruise/itenarary/activity.png",
    flight: "/assets/images/cruise/itenarary/flight1.png",
  };

  const [mainImages, setMainImages] = useState([]);

  useEffect(() => {
    if (data?.itineraries?.length > 0) {
      const defaultImages = data.itineraries.map(
        (item) => item?.images?.[0]?.image || "",
      );

      setMainImages(defaultImages);
    }
  }, [data]);

  const changeMainImage = (index, img) => {
    const updated = [...mainImages];
    updated[index] = img;
    setMainImages(updated);
  };

  return (
    <div className="Itinerary_Tab">
      <>
        <div className="city_header">
          {data?.title} - <span>{data?.duration}</span>
        </div>

        <Accordion defaultActiveKey="0" className="custom_accordion">
          {data?.itineraries?.map((d, index) => (
            <Accordion.Item eventKey={index.toString()}>
              <Accordion.Header>
                {d?.title}

                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="inner_icon down_icon"
                  />
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className="inner_icon up_icon"
                  />
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <Day1Card
                  item={d}
                  icons={icons}
                  mainImage={mainImages[index]} // ✅ important
                  changeMainImage={(img) => changeMainImage(index, img)}
                />
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </>
    </div>
  );
};

export default Itinerary_Tab;
